import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal-aviso-acesso-camera',
  templateUrl: './modal-aviso-acesso-camera.component.html',
  styleUrls: ['./modal-aviso-acesso-camera.component.scss'],
})
export class ModalAvisoAcessoCameraComponent {
  closeModal: Subject<boolean> = new Subject();

  constructor(private modalInstance: BsModalRef) {}

  close() {
    this.closeModal.next(true);
    this.modalInstance.hide();
  }
}
